export default __webpack_public_path__ + "static/media/Global.d5c56cdb.jpg";